<template>
    <BreadCrumb v-if="showgrid" page="Beranda > Pendaftaran > Data Assessment > Data Jadwal Asesmen"></BreadCrumb>
    <div class="container-fluid content-area" v-if="showgrid">
      <div class="row">
        <div class="col-md-12">
          <h3 class="judul-seksi-sga">Data Jadwal Asesmen</h3></div>
      </div>
      <div class="" style="padding-top: 20px;">
        <div class="row">
          <div class="col-12">
            <div class="table-responsive">
              <DataTable v-model:filters="filters" :value="dataAssessmentList" ref="dt" tableStyle="min-width: 50rem"
                         paginator :rows="10"
                         :rowsPerPageOptions="[5, 10, 20, 50]"
                         :first="0"
                         :loading="loading"
              >
                <template #header>
                  <div class="flex justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Keyword Search" />
                    </span>
                  </div>
                </template>
                <template #empty> Data tidak ada. </template>
                <template #loading> Mengambil data. Mohon tunggu. </template>
                <Column field="hari" header="Hari" sortable></Column>
                <Column field="tanggal" header="Tanggal" sortable></Column>
                <Column field="sesi_waktu" header="Sesi" sortable></Column>
                <Column field="anak_nama" header="Nama Anak" filterMatchMode="startsWith" sortable>
                </Column>
                <Column field="ortu_nama" header="Nama Ortu" sortable style="width: 25%"></Column>
                <Column header="Lihat">
                  <template #body="slotProps">
                    <a href="#" @click="toggleGrid(slotProps.data)" class="fa-solid fa-eye" ></a>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DataHasilAssesment
      :data="selectedFormulir" v-if="!showgrid"
      @change-view="toogleviewshowgrid">
    </DataHasilAssesment>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import DashboardServices from "@/services/dashboard.services";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { FilterMatchMode } from '@primevue/core/api';
import DataHasilAssesment from "@/components/viewadmin/assessment/DataHasilAssesment";
import InputText from "primevue/inputtext";

export default {
  name: "PageViewDataJadwalAssessment",
  components: {DataHasilAssesment, BreadCrumb,DataTable,Column,InputText},
  data:()=>({
    loading: false,
    lazyParams: {},
    showgrid: true,
    response:'',
    message:'',
    success: false,
    dataWawancara:[],
    dataAssessmentList:[],
    selectedFormulir:[],
    totalRecords: 0,
    filters: {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      'no_formulir': {value: '', matchMode: FilterMatchMode.CONTAINS},
      'nama_anak': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'nama_ortu': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'jadwal_wawancara': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
      'tanggal_wawancara': {value: '', matchMode: FilterMatchMode.STARTS_WITH},
    },
  }),
  methods:{
    toogleviewshowgrid(){
      this.showgrid = true;
    },
    toggleGrid(data){
      this.showgrid = !this.showgrid;
      this.selectedFormulir = data;
    },
    generatelink(invchild){
      return "/admin/data/view-formulir-psb/"+invchild;
    },
    getDataAssessmentList(){
      this.loading = true;
      this.$store.commit('loading',this.loading);
      let data = this.lazyParams;
      let path = '/dashboard/getDataAssessmentSiswa';
      DashboardServices.postData(data,path).then(
          (response)=>{
            this.response = response.data;
            this.message = response.data.message;
            if(response.data.status===200){
              this.success = true;
              this.dataAssessmentList = this.response.data;
            }else {
              this.success = false;
            }
            this.loading = false;
            this.$store.commit('loading',this.loading);
          }
      );
    },

  },
  mounted() {
    this.lazyParams = {
      first: this.$refs.dt.first,
      rows: this.$refs.dt.rows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    this.getDataAssessmentList();
  }
}
</script>

<style scoped>

</style>